<template>
  <div class="info">
<!--    <HomePic/>-->
<!--    <BreadNav/>-->
    <div class="sub-main">
<!--      <div class="left">-->
<!--        <LeftMenu/>-->
<!--      </div>-->
      <div class="right">
        <NewsList
                  :show-page="true"
                  :show-search="false"
                  :showTitle="true">

        </NewsList>
      </div>
    </div>
  </div>
</template>

<style lang="less">
</style>

<script>
import HomePic from '@/components/style2/HomePic.vue';
import BreadNav from '@/components/style2/BreadNav.vue';
import LeftMenu from '@/components/style2/LeftMenu.vue';
import NewsList from '@/components/style2/NewsList.vue';

export default {
  name: 'Info',
  components: {
    HomePic, BreadNav, NewsList,LeftMenu
  },
  computed: {
    keyword() {
      return this.$store.state.keyword;
    },
  },
};
</script>
